import axios from 'axios';

export const getTwitterInfo = async (screenName) =>
  (await axios.get(`https://twit.atomic.finance/user/${screenName}`)).data;

export const getTwitterInfoById = async (id) =>
  (await axios.get(`https://twit.atomic.finance/id/${id}`)).data;
